import logdown from 'logdown';

interface LogUtilsType {
  PREFIX_DATLOWE: string;
  PREFIX_DEBUG: string;
  getLogger: (component: string, prefix: string) => logdown.Logger;
  getDebugLogger: (component: string, prefix: string) => logdown.Logger;
  toggleLogging: (prefixes: string) => void;
}

const LogUtils: LogUtilsType = {
  PREFIX_DATLOWE: 'datlowe',
  PREFIX_DEBUG: 'DEBUG_',

  getLogger(component, prefix = LogUtils.PREFIX_DATLOWE) {
    return logdown(`${prefix}:${component}`, {
      markdown: false,
      prefixColor: '#49cc96',
    });
  },

  getDebugLogger(component, prefix = LogUtils.PREFIX_DATLOWE) {
    return LogUtils.getLogger(component, `${LogUtils.PREFIX_DEBUG}${prefix}`);
  },

  toggleLogging(prefixes) {
    window.localStorage.debug = prefixes;
  },
};

export default LogUtils;
